import { Button, Card, Col, Container, FloatingLabel, Form, Modal, Ratio, Row } from "react-bootstrap"
import "./Show.css"
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useGetShowByIdQuery, useGetShowGalleryDetailsQuery } from "../../features/CallApi";
import { LoadScreenMin } from "../UI/LoadScreenMin";
import parse from 'html-react-parser';
import PhotoAlbum from 'react-photo-album';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

// import optional lightbox plugins
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/captions.css";
import { Helmet } from "react-helmet";
import { ShowSchedulesItem } from "../UI/ShowSchedulesItem";
import { useDispatch, useSelector } from "react-redux";
import { useTokenTP } from "../../features/useTokenTP";
import { usePostWaitListMutation, usePutPersonMutation } from "../../features/CallTPApi";
import { useForm } from "react-hook-form";
import { setAlertMsgStore } from "../../features/alertMsgSlisce";
import { InputPhone } from "../PayTickets/InputPhone";
import { BuyButton, DateBtn } from "../Afisha/AfishaSlider";

const BUTTON_TYPES = {
    SCHEDULE: 0,  // Изменено на строки
    LINK: 1,      // потому что select возвращает строку
    WAITING_LIST: 2
};


const WaitListForm = ({ item }) => {
    const [t] = useTranslation("global");
    const [show, setShow] = useState(false)
    const whoami = useSelector((state) => state.whoamiTP)
    const [disabledForm, setDisabledForm] = useState(false)
    const { logOutTP } = useTokenTP()
    const [putPerson, { isLoading: isPutPerson }] = usePutPersonMutation()
    const dispatch = useDispatch()
    const [postWaitLists, { isLoading }] = usePostWaitListMutation()

    const { register, handleSubmit, formState: { errors }, reset, setValue, setError } = useForm({ mode: 'onChange' });
    const submitForm = async (data) => {
        const body = {
            ...data,
            eventId: item.waitListButtonEventId,
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            phone: data.phone,

        }
        if (disabledForm) {
            console.log("не обновляем данные покупателя")
            createWaitList(body)
        } else {
            console.log("обновляем данные покупателя")
            const personNewData = {
                id: data.id,
                firstName: data.firstName,
                lastName: data.lastName,
                eMail: data.eMail,
                phone: '+' + data.phone.replace(/\D+/g, ""),
            };
            await putPerson(personNewData).then(async (res) => {
                console.log(!res.error)
                if (!res.error) {
                    createWaitList(body)
                }
                else {
                    dispatch(setAlertMsgStore({ title: `Ошибка обновления данных покупателя.`, variant: 'danger' }))
                }
            })
        }
        return
    }

    const createWaitList = async (data) => {
        console.log(data)
        const body = {
            comment: data.comment,
            eventId: item.waitListButtonEventId,
            ticketCount: data.ticketCount,
            clientId: whoami.id,
            createdById: whoami.id,
            modifiedById: whoami.id,
            waitListStatus: 1,
        }
        postWaitLists(body).then((res) => {
            if (!res.error) {
                dispatch(setAlertMsgStore({ title: `Заявка успешно отправлена!`, variant: 'success' }))
                reset()
                setShow(false)
            }
            if (res.error) {
                dispatch(setAlertMsgStore({ title: `Ошибка создания заявки.`, variant: 'danger' }))
            }
        })
    }

    const agreementLable = () => {
        return (
            <label className="form-check-label" style={{ fontSize: '12px' }}><a href='https://leningradcenter.ru/api/redirecturls/privacy-policy' target={"_blank"} >{t("form.agreement")}</a></label>
        )
    }
    const praviloLable = () => {
        return (
            <label className="form-check-label" style={{ fontSize: '12px' }}><a href='https://leningradcenter.ru/api/redirecturls/public-offer-certificates' target={"_blank"} >{t("form.giftRules")}</a></label>
        )
    }

    useEffect(() => {
        if (whoami) {
            console.log(disabledForm)
            setValue('id', whoami.id)
            setValue('phone', whoami.phone)
            setValue('firstName', whoami.firstName)
            setValue('lastName', whoami.lastName)
            setValue('eMail', whoami.eMail)
            // setNewStatus()

            if (whoami.firstName && whoami.lastName && whoami.eMail) {
                setDisabledForm(true)
                console.log(true)
            }
        }
    }, [whoami])

    return (
        <>
            <Button className='border shadow btn-afisha' style={{
                borderColor: "#272929"
            }} onClick={() => {
                setShow(true)
            }} variant='light'>{item.waitListButtonEventText}</Button>
            <Modal show={show} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Регистрация в листе ожидания</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!whoami?.id ?
                        <div>
                            <div className='pe-lg-5 ps-lg-5'>
                                <InputPhone />
                            </div>
                        </div>
                        :
                        <Form onSubmit={handleSubmit(submitForm)} className=''>
                            <div className='d-grid gap-1'>
                                <div className='fs-5 fw-bold'>
                                    {item.name}
                                </div>
                                <FloatingLabel label="Количество билетов">
                                    <Form.Control
                                        type="number"
                                        min={0} // Запрещает ввод значений меньше 0
                                        step={1} // Только целые числа
                                        isInvalid={!!errors.ticketCount}
                                        {...register("ticketCount", {
                                            required: { value: true, message: "Введите количество билетов" },
                                            valueAsNumber: true, // Преобразует строку в число (возвращает number)
                                            setValueAs: (value) => Number(value) || 0, // Преобразование при установке
                                            min: {
                                                value: 0,
                                                message: "Количество билетов не может быть меньше 0"
                                            }
                                        })}
                                        placeholder="0"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.ticketCount?.message?.toString()}
                                    </Form.Control.Feedback>
                                </FloatingLabel>
                                <FloatingLabel label="Комментарий">
                                    <Form.Control
                                        as="textarea"
                                        placeholder="Введите комментарий"
                                        style={{ height: '100px' }}
                                        {...register('comment', {
                                            required: 'Опишите ваш запрос. Например, укажите желаемые места в зале, дату или другие важные детали',
                                        })}
                                        isInvalid={!!errors.comment}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.comment?.message?.toString()}
                                    </Form.Control.Feedback>
                                </FloatingLabel>
                                <FloatingLabel label="Телефон">
                                    <Form.Control placeholder="Телефон" disabled={true} {...register('phone')} />
                                </FloatingLabel>
                                <div className='d-flex gap-1'>
                                    <FloatingLabel label="Имя" className='flex-fill'>
                                        <Form.Control placeholder="Имя" isInvalid={errors?.firstName ? true : false} disabled={disabledForm} {...register('firstName', { required: true })} />
                                    </FloatingLabel>
                                    <FloatingLabel label="Фамилия" className='flex-fill'>
                                        <Form.Control placeholder="Фамилия" isInvalid={errors?.lastName ? true : false} disabled={disabledForm}  {...register('lastName', { required: true })} />
                                    </FloatingLabel>
                                </div>
                                <FloatingLabel label="E-mail">
                                    <Form.Control placeholder="E-mail" isInvalid={errors?.eMail ? true : false} disabled={disabledForm}  {...register('eMail', {
                                        required: true, pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                            message: "invalid email address"
                                        }
                                    })} />
                                </FloatingLabel>
                                {disabledForm &&
                                    <Button variant="light" onClick={() => { setDisabledForm(false) }} size="sm">Изменить данные</Button>
                                }
                                <Button className='mb-2' variant="link" size='sm' onClick={() => { logOutTP() }}>Выйти из профиля</Button>
                                <div>
                                    <div className="d-flex mb-2">
                                        <Form.Switch label={agreementLable()}
                                            className="check-input-lc"
                                            isInvalid={errors.policy?.message !== undefined}
                                            {...register("policy",
                                                { required: { value: true, message: "Необходимо согласие на обработку персональных данных" } }
                                            )} />
                                    </div>
                                    {/* <div className="d-flex">
                                        <div className=" form-check form-switch">
                                            <label className="form-check-label " style={{ fontSize: "12px" }}>{t("form.receiveNewsletter")}</label>
                                            <input type="checkbox" className="form-check-input check-input-lc" {...register("receiveNewsletter", {})} />
                                        </div>
                                    </div> */}
                                </div>
                                <div className='d-flex'>
                                    <input type={'submit'} value={t("form.confirm")} className='btn btn-lc btn-lc-cert w-auto flex-fill' />
                                </div>
                            </div>
                        </Form>
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}

const ButtonAfisha = ({ item, setShowModel }) => {
    const [t] = useTranslation('global')

    return (
        <div className='d-grid gap-1' size='sm'>
            {/* {item.buttonType} */}
            {(item.showSchedules?.length > 0 && item.buttonType === BUTTON_TYPES.SCHEDULE) &&
                <Button className='border shadow btn-afisha' style={{ borderColor: "#272929" }} onClick={() => {
                    setShowModel(true)
                }} variant='light'>{t("afisha.buytickets")}</Button>
                // :
                // <Button className='border shadow btn-afisha' variant='light'>{t("afisha.subscribe")}</Button>
            }
            {item.buttonType === BUTTON_TYPES.LINK &&
                <Button className='border shadow btn-afisha' style={{
                    borderColor: "#272929"
                }} onClick={() => {
                    window.open(item.buyButtonLink, '_blank').focus();
                }} variant='light'>{item.buyButtonText}</Button>
            }
            {item.buttonType === BUTTON_TYPES.WAITING_LIST &&
                <WaitListForm item={item} />
            }
            {/* <Button><BoxArrowInRight size={18} /></Button> */}
        </div>
    )
}

const HaedLayout = (props) => {
    return (<div className="haed-layout">
        <div className="head-layout-img" style={{
            backgroundImage: props.data.headLayoutImageType ? `url(api/shows/head-wide-img/${props.data.id})` : "url(/Show/091A8332.jpg"
        }}>
        </div>
        <div className="head-mask">
        </div>
    </div>);
}

const DataShow = (props) => {
    return (
        <>
            <h1 className="fs-3"><strong>{props.data.name}</strong></h1>
            <p>
                <strong>
                    {props.data.shortDescription}
                </strong>
            </p>
            <p>
                {(props.data?.director !== "" && props.data.director !== undefined) && <>
                    {props.t("show.director")} — <strong>
                        {props.data.director}
                    </strong>
                </>}
            </p>
            <p>
                {props.t("show.duration")}: {props.data.duration}
            </p>
            <p>
                {props.t("show.age")} <strong>{props.data.ageCategory}+</strong>
            </p>
            <div>
                {props.data.buttonType === 0 && props.data.showSchedules?.length > 0 && (
                    <div>
                        {/* <p className="afisha-date-label">Выберите дату</p> */}
                        <div className="d-flex flex-wrap gap-1 mb-2">
                            {props.data.showSchedules.slice(0, 5).map((date) => (
                                <DateBtn key={date.id} schedule={date} />
                            ))}
                            {props.data.showSchedules.length > 5 && (
                                <span className="afisha-more-dates">+{props.data.showSchedules.length - 5}</span>
                            )}
                        </div>
                    </div>
                )}

                <div className="d-flex align-items-center justify-content-between flex-fill">
                    <BuyButton item={props.data} />
                </div>
            </div>

        </>
    );
}


export const Show = () => {

    const { seoUrl } = useParams("seoUrl")
    const [t] = useTranslation("global");
    const [selLng, setSelLng] = useState('')
    const navigate = useNavigate()
    let [searchParams, SetSearchParams] = useSearchParams();

    useEffect(() => {
        if (localStorage.getItem("selLng") !== null) {
            setSelLng(localStorage.getItem("selLng"))
        }
    }, [t])

    const { data, isLoading, status } = useGetShowByIdQuery({ seoUrl, selLng });
    const { data: photosData, refetch } = useGetShowGalleryDetailsQuery(seoUrl)

    const [showModel, setShowModel] = useState(false)
    const [dateList, setDateList] = useState()
    const [index, setIndex] = useState(-1);
    const [photos, setPhotos] = useState()

    const loaction = useLocation()
    const [wide, setWide] = useState();
    const [wideHead, setWideHead] = useState();

    useEffect(() => {
        if (window.innerWidth <= 768) {
            setWide(false)
        }
        if (window.innerWidth > 768) {
            setWide(true)
        }
        if (window.innerWidth <= 1160) {
            setWideHead(false)
        }
        if (window.innerWidth > 1160) {
            setWideHead(true)
        }
        refetch()
    }, [])

    useEffect(() => {
        if (photosData?.length > 0 && data != null) {
            const links = [];
            (photosData).forEach(item => {
                links.push({ src: `/api/shows/gallery-photo/${item.id}`, width: item.photoWidth, height: item.photoHeight, alt: data.name })
            });
            setPhotos(links)
        }
    }, [photosData, data])

    useEffect(() => {
        const resizeHandeler = (e) => {
            if (e.target.window.innerWidth <= 768) {
                setWide(false)
            }
            if (e.target.window.innerWidth > 768) {
                setWide(true)
            }
            if (e.target.window.innerWidth <= 1160) {
                setWideHead(false)
            }
            if (e.target.window.innerWidth > 1160) {
                setWideHead(true)
            }
            // console.log(e.target.window.innerWidth)
            // console.log(e.target.window.innerHeight)
        }

        window.addEventListener('resize', resizeHandeler)
        return function () {
            window.addEventListener('resize', resizeHandeler)
        }
    }, [loaction])

    useEffect(() => {
        if (status === "rejected") {
            navigate("/notfonund")
        }
    }, [status])

    useEffect(() => {
        if (data) {
            if (searchParams.get('showModal') === 'true') {
                setShowModel(true)
                setDateList(data.showSchedules)
            }
        }
    }, [data])

    const setParam = (seoUrl) => {
        console.log("showModal")
        console.log(seoUrl)
        searchParams.set("showModal", 'true')
        searchParams.append("selectShow", seoUrl)
        SetSearchParams(searchParams)
    }

    const hideModal = () => {
        console.log("hiddenModal")
        setShowModel(false)
        setDateList(null)
        searchParams.delete("selectShow")
        searchParams.delete("showModal")
        SetSearchParams(searchParams)
    }


    return (
        <>
            {showModel &&
                <Modal
                    show={showModel}
                    size="md"
                    fullscreen={"sm-down"}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    // backdrop="static"
                    onHide={() => {
                        hideModal()
                    }}
                    onShow={() => {
                        setParam(data.id)
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {t("afisha.selectdate")}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {data?.showSchedules &&
                            <>
                                {data.showSchedules.map(item =>
                                    <ShowSchedulesItem key={item.id} item={item} />
                                )}
                            </>
                        }
                    </Modal.Body>
                    {/* <Modal.Footer>
                    <Button onClick={() => setShowModel(false)}>{t("general.close")}</Button>
                    
                </Modal.Footer> */}
                </Modal>
            }
            {!isLoading ? <>
                {data && <>
                    <Helmet>
                        <title>{`${data.name} - Ленинград Центр`}</title>
                        <meta name="description" content={data.seoDescription || `Первое в России шоу-пространство "Ленинград Центр"`} />
                        <meta name="robots" content="index, follow" />

                        <meta property="og:url" content={`https://leningradcenter.ru/about-project/show/${data.seoUrl}`} />
                        <meta property="og:type" content="wibsite" />
                        <meta property="og:title" content={`${data.name} - Ленинград Центр`} />
                        <meta property="og:description" content={data.seoDescription || `Первое в России шоу-пространство "Ленинград Центр"`} />
                        <meta property="og:image" content={`https://leningradcenter.ru/api/shows/head-img/${data.id}`} />
                        <meta property="og:site_name" content="Ленинград Центр" />
                        <meta property="og:locale" content="ru_RU" />

                        <meta name="twitter:card" content="summary_large_image" />
                        <meta property="twitter:domain" content="leningradcenter.ru" />
                        <meta property="twitter:url" content={`https://leningradcenter.ru/about-project/show/${data.seoUrl}`} />
                        <meta name="twitter:title" content={`${data.name} - Ленинград Центр`} />
                        <meta name="twitter:description" content={data.seoDescription || `Первое в России шоу-пространство "Ленинград Центр"`} />
                        <meta name="twitter:image" content={`https://leningradcenter.ru/api/shows/head-img/${data.id}`} />
                    </Helmet>
                    <HaedLayout data={data} />
                    <Container className="pt-3">
                        <Row className="justify-content-center">
                            {data?.linkVideo ?
                                <>
                                    {wide === true &&
                                        <Col lg={7}>
                                            <Ratio aspectRatio="16x9" className="mb-3">
                                                <iframe className="embed-responsive-item" src={data.linkVideo} allowFullScreen={true}>
                                                </iframe>
                                            </Ratio>
                                        </Col>
                                    }
                                </>
                                :
                                // <Col lg={5} className="text-center d-none d-lg-block">
                                //     <img src={`/api/shows/head-img/${id}`} alt={`Афиша ${data.name}`} style={{ maxHeight: '55vh' }} className="img-fluid" />
                                // </Col>
                                <Col lg={6}>
                                    {photosData &&
                                        <div className="mb-3">
                                            <PhotoAlbum columns={3} layout="masonry" photos={photos} onClick={({ index }) => setIndex(index)} />
                                            <Lightbox
                                                slides={photos}
                                                open={index >= 0}
                                                index={index}
                                                close={() => setIndex(-1)}
                                                // enable optional lightbox plugins
                                                plugins={[Slideshow, Thumbnails, Zoom, Captions]}
                                            />
                                        </div>
                                    }
                                </Col>
                            }
                            <Col lg={data?.linkVideo ? 5 : 6}>
                                {(data?.linkVideo !== null && data?.linkVideo !== "") ?
                                    <div className="mb-3">
                                        <PhotoAlbum columns={3} layout="masonry" photos={photos} onClick={({ index }) => setIndex(index)} />
                                        <Lightbox
                                            slides={photos}
                                            open={index >= 0}
                                            index={index}
                                            close={() => setIndex(-1)}
                                            // enable optional lightbox plugins
                                            plugins={[Slideshow, Thumbnails, Zoom, Captions]}
                                        />
                                    </div> :
                                    <DataShow t={t} data={data} setShowModel={setShowModel} />
                                }
                            </Col>

                        </Row>
                        {/* <Row className="justify-content-around">
                            <Col lg={"auto"} className="text-center">

                            </Col>
                            <Col lg={6}>

                            </Col>
                        </Row> */}
                        {data?.linkVideo && <>
                            {
                                wide === false && <>
                                    <Ratio aspectRatio="16x9 mb-3">
                                        <iframe className="embed-responsive-item" src={data.linkVideo} allowFullScreen={true}>
                                        </iframe>
                                    </Ratio>
                                </>
                            }
                        </>
                        }
                        <div className="mt-3">
                            {(data?.linkVideo !== null && data?.linkVideo !== "") ?
                                <>
                                    <Row>
                                        {!wide &&
                                            <Col lg={5}>
                                                <DataShow t={t} data={data} setShowModel={setShowModel} />
                                            </Col>
                                        }
                                        <Col>
                                            {data.description && parse(data.description)}
                                            <p>
                                                <i>{t("show.afterStart")}</i>
                                            </p>
                                        </Col>
                                        {wide &&
                                            <Col lg={5}>
                                                <DataShow t={t} data={data} setShowModel={setShowModel} />
                                            </Col>
                                        }
                                    </Row>
                                </>
                                :
                                <>
                                    {data.description && parse(data.description)}
                                    <p>
                                        <i>{t("show.afterStart")}</i>
                                    </p>
                                </>
                            }
                        </div>
                    </Container>
                    {/* {navbarRef && */}
                    <div className="position-fixed p-2 w-100 bg-white d-lg-none text-center"
                        style={{ bottom: 64, zIndex: 1000 }}
                    >
                        <ButtonAfisha item={data} setShowModel={setShowModel} />
                    </div>
                    {/* } */}
                </>
                }
            </> : <LoadScreenMin />}
        </>
    )
}